<template>
	<main class="w-full">
		<nav class="bg-white py-8">
			<div class="vx-row justify-center">
				<div class="vx-col w-5/6 md:w-3/4 lg:w-5/6">
					<section class="flex items-center">
						<router-link to="/">
							<img src="/green-logo.png" alt="" class="w-12 mr-4" />
						</router-link>
						<strong class="text-primary">{{$route.meta.pageTitle}}</strong>
					</section>
				</div>
			</div>
		</nav>
		<router-view></router-view>
		<the-lite-footer />
	</main>
</template>
<script>
import TheLiteFooter from '@/layouts/components/TheLiteFooter.vue'
export default {
  components: {
    TheLiteFooter
  }
}
</script>